import { render, staticRenderFns } from "./SidebarControlEscolar.vue?vue&type=template&id=9c16d342&"
import script from "./SidebarControlEscolar.vue?vue&type=script&lang=js&"
export * from "./SidebarControlEscolar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports